import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";
import {
  ADD_PRODUCT,
  GET_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  PRODUCT_DETAIL,
} from "../../config/constants";

const productStore = createApi({
  reducerPath: "productStore",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (bodyData) => ({
        url: GET_PRODUCT,
        method: "POST",
        data: bodyData,
      }),
      providesTags: ["Product"],
      keepUnusedDataFor: 3000,
    }),
    addProduct: builder.mutation({
      query: (productData) => ({
        url: ADD_PRODUCT,
        method: "POST",
        data: productData,
      }),
      invalidatesTags: ["Product"],
    }),
    updateProduct: builder.mutation({
      query: ({ productId, updatedData }) => ({
        url: `${UPDATE_PRODUCT}/${productId}`,
        method: "PUT",
        data: updatedData,
      }),
      invalidatesTags: ["Product"],
    }),
    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `${DELETE_PRODUCT}/${productId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),
    getProductDetail: builder.query({
      query: (productId) => ({
        url: `${PRODUCT_DETAIL}/${productId}`,
        method: "GET",
      }),
      providesTags: ["Product"],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetProductDetailQuery,
} = productStore;

export default productStore;
